const downloadResult = {
  fileName: 'File Name',
  columns: {
    fileName: 'Filename'
  },
  modal: {
    detailDataDanFormat: {
      title: 'Detail Data and Format'
    }
  }
}

export default downloadResult